var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgBonusesIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 16 16",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#2C363F",
    d: "M5.5625 2h.0516c.7476 0 1.4414.3963 1.821 1.0418L8 4.003l.5648-.9612A2.114 2.114 0 0 1 10.386 2h.0516c1.139 0 2.0624.9234 2.0624 2.0625 0 .3375-.082.6352-.225.9375h.975c.4148 0 .75.3352.75.75v1.5c0 .4148-.3352.75-.75.75H2.75A.7496.7496 0 0 1 2 7.25v-1.5c0-.4148.3359-.75.75-.75h.975c-.144-.3023-.225-.6-.225-.9375C3.5 2.9235 4.4234 2 5.5625 2m.9023 1.612a.989.989 0 0 0-.8507-.487h-.0516a.9374.9374 0 0 0-.9375.9375c0 .518.4195.9375.9375.9375h1.718zm3.9727-.487h-.0516a.989.989 0 0 0-.8507.487L8.7195 5h1.718a.937.937 0 0 0 .9375-.9375.9374.9374 0 0 0-.9375-.9375M2.75 8.75h4.5V14H3.875c-.6213 0-1.125-.5039-1.125-1.125zm6 5.25V8.75h4.5v4.125c0 .6211-.5039 1.125-1.125 1.125z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgBonusesIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/bonuses-icon.4dabbc73d1db4b2ec4be7d85f69e721e.svg";